import { render, staticRenderFns } from "./VContenteditable.vue?vue&type=template&id=b1da01e2"
import script from "./VContenteditable.vue?vue&type=script&lang=js"
export * from "./VContenteditable.vue?vue&type=script&lang=js"
import style0 from "./VContenteditable.vue?vue&type=style&index=0&id=b1da01e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports